import { useEffect, useRef } from "react";
import type { MatchSummary, ResultStatusFilter } from "../types";

type MatchSummaryPopoverProps = {
  summary: MatchSummary;
  activeFilter: ResultStatusFilter;
  onFilterChange: (filter: ResultStatusFilter) => void;
  onClose: () => void;
};

const MatchSummaryPopover = ({ summary, activeFilter, onFilterChange, onClose }: MatchSummaryPopoverProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) onClose();
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  const rows: { key: ResultStatusFilter; label: string; count: number; dotClass: string }[] = [
    { key: "AUTO_MATCHED", label: "Auto-Matched", count: summary.auto_matched, dotClass: "tw-bg-success-600" },
    { key: "NEEDS_REVIEW", label: "Need Review", count: summary.needs_review, dotClass: "tw-bg-semantic-yellow-900" },
    { key: "NO_MATCH", label: "No Match", count: summary.no_match, dotClass: "tw-bg-error-500" },
  ];

  return (
    <div ref={containerRef} className="tw-absolute tw-left-1/2 tw-top-full tw-z-50 tw-mt-2 tw-w-64 -tw-translate-x-1/2 tw-rounded-xl tw-border tw-border-gray-200 tw-bg-white tw-p-2 tw-shadow-autoSuggest">
      <div className="tw-px-2 tw-py-1 tw-text-sm tw-font-semibold tw-text-gray-900">Match Summary</div>
      {rows.map((row) => (
        <button key={row.key} type="button" onClick={() => onFilterChange(activeFilter === row.key ? "ALL" : row.key)} className={`tw-flex tw-w-full tw-items-center tw-justify-between tw-rounded-md tw-border-none tw-px-2 tw-py-2 tw-text-sm hover:tw-bg-gray-50 ${activeFilter === row.key ? "tw-bg-primary-purple-50" : "tw-bg-transparent"}`}>
          <span className="tw-flex tw-items-center tw-gap-2 tw-text-gray-700">
            <span className={`tw-h-2 tw-w-2 tw-rounded-full ${row.dotClass}`} />
            {row.label}
          </span>
          <span className="tw-font-medium tw-text-gray-900">{row.count}</span>
        </button>
      ))}
    </div>
  );
};

export default MatchSummaryPopover;
